import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useRequest } from "../../../hooks/useRequest";
import { Skeleton } from "@mui/material";
import { getDate } from "../../../utils/helper";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import useDebounce from "../../../hooks/useDebounce";
import Sort from "../../../components/common/Sort";
import { priceSymbol } from "../../../utils/symbol";

const PurchaseHistoryStyle = styled.div`
  flex: 1;
  overflow-x: auto;
  min-width: 500px;
  width: 100%;
  > .subtitle {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: #666666;
    margin: 12px 0;
  }
  .purchases__found {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin: 12px 0;
    span {
      font-weight: 700;
    }
  }
  .order__history__table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    tr {
      th,
      td {
        padding: 10px;
        font-size: 12px;
        font-weight: 400;
        line-height: 22px;
        text-align: left;
        border: 1px solid #d2d1d1;
        width:25%;
        text-transform: capitalize;
      }
      .MuiTablePagination-root {
        padding: 0;
        P {
          font-size: 13px;
          font-weight: 400;
          line-height: 22px;
        }
      }
      th {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .table__data__row {
      cursor: pointer;
      &:hover {
        background-color: #ffeeee;
      }
    }
  }
`;

const PurchaseHistorySort = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: #f2f2f2;
  padding: 12px;
  border: 0.77px solid #cccccc;
  .purchase__history__date__range,
  .purchase__history__search {
    flex: 1;
  }
  .filter__title {
    font-size: 10px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    margin-bottom: 2px;
  }
  .date__filter {
    display: flex;
    gap: 4px;
    .date {
      height: 32px;
      padding: 4px 10px;
      border-radius: 3px;
      font-size: 12px;
      color: #303030;
      cursor: pointer;
    }
  }
  .purchase__history__clear {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #286fad;
    text-underline-offset: 1px;
    cursor: pointer;
    padding-right: 30px;
    &:hover {
      text-decoration: underline;
    }
  }
  .purchase__history__sorting__styled {
    background-color: #fff;
    border-radius: 3px;
    .product__current__sorting {
      height: 32px;
      padding: 4px 10px;
      font-weight: 400;
      color: #303030;
    }
    .products__sorting__dropdown__wrapper {
      width: 130px;
    }
  }
`;

const SearchbarStyle = styled.form`
  height: 32px;
  display: flex;
  position: relative;
  border-radius: 3px;
  overflow: clip;
  width: 100%;
  input {
    height: 32px;
    width: 100%;
    padding: 0 12px;
    font-size: 12px;
  }
  .search__button {
    width: 39px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ae0000;
    .icon {
      display: block;
      color: #fff;
      font-size: 18px;
    }
  }
`;

const sortingOptions = [
  // {
  //   label: "Select Option",
  //   value: "",
  // },
  // {
  //   label: "Order Id (Ascending)",
  //   value: "orderId",
  //   sortOrder: "asc",
  // },
  // {
  //   label: "Order Id (Descending)",
  //   value: "orderId",
  //   sortOrder: "desc",
  // },
  // {
  //   label: "Subtotal",
  //   value: "subtotal",
  // },
  // {
  //   label: "Total",
  //   value: "total",
  // },
  {
      label: "Group Buy",
      value: "groupBy",
    },
  {
      label: "Instabuild",
      value: "instabuild",
    },
  {
      label: "Order ID",
      value: "orderID",
    },
];


const RewardHistory = () => {
  const [getOrderHistory, { isLoading }] = useRequest();
  const [pageNumber, setPageNumber] = useState(1);
  const [limitNumber, setLimitNumber] = useState(10);
  const [orderHistory, setOrderHistory] = useState([]);
  const navigate = useNavigate();

  useDebounce(
    () => {
      pageNumber &&
        limitNumber &&
        fetchOrderSummary(
          pageNumber,
          limitNumber,
        );
    },
    [
      pageNumber,
      limitNumber,
    ],
    500
  );

  const fetchOrderSummary = async (
    pageNumber,
    limitNumber
  ) => {
    const path = `/reward/history?${limitNumber ? `limit=${limitNumber}` : ""}${
      pageNumber ? `&page=${pageNumber}` : ""
    }`;
    const response = await getOrderHistory({ path });
    if (response.success) {
      setOrderHistory(response?.data);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPageNumber(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimitNumber(+event.target.value);
    setPageNumber(1);
  };
  
  return (
    <PurchaseHistoryStyle>
      <p className="subtitle">Here is a history of all your rewards.</p>
      {!isLoading && (
        <div className="purchases__found">
          {orderHistory?.totalDocs ? (
            <span>{orderHistory?.totalDocs}</span>
          ) : (
            "No"
          )}{" "}
          Reward found
        </div>
      )}
      <table className="order__history__table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Order ID</th>
            <th>Product Name</th>
            <th>Amount($)</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <>
              {Array.from({ length: limitNumber }, (_, index) => index + 1).map(
                (item) => (
                  <tr key={item}>
                    {Array.from({ length: 5 }, (_, index) => index + 1).map(
                      (item2) => (
                        <td key={item2}>
                          <Skeleton height={24} variant="rectangular" />
                        </td>
                      )
                    )}
                  </tr>
                )
              )}
            </>
          ) : (
            <>
              {orderHistory?.docs?.map((item) => (
                <tr
                  className="table__data__row"
                  key={item?._id}
                  onClick={() => navigate(`/account/transaction/${item?.orderId?._id || ""}`)}
                >
                  <td>{getDate(item?.date)}</td>
                  <td>{item?.orderId?.orderId || "--"}</td>
                  <td>{item?.orderId?.items?.length > 0 ? item?.orderId?.items[0]?.name : "--"}</td>
                  <td>{item?.amount || "--"}</td>
                  <td>{item?.type || "--"}</td>
                </tr>
              ))}
            </>
          )}
          <tr>
            <TablePagination
              rowsPerPage={limitNumber}
              rowsPerPageOptions={[5, 10, 15, 20, 25, 100]}
              page={pageNumber - 1}
              count={orderHistory?.totalDocs}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </tr>
        </tbody>
      </table>
    </PurchaseHistoryStyle>
  );
};

export default RewardHistory;
